import { INPUT_TYPE } from "@Modules/core/components/form/CustomInput";
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { Fragment } from "react";
import { FiCheckCircle, FiCircle } from 'react-icons/fi';
import { getDetailName } from "./getDetailName";

export default function displayCustomFields<T>(meta: any,  inputs?: string[], isLabel?: string, excluded?: string[]) {
    // const arr = (inputs && inputs?.length > 0) ? inputs : getFormFieldsName(meta, excluded);
    let arr: string[] = [];

    const excludedArray = excluded ? [...excluded] : [];
    if(inputs && inputs?.length > 0) {
        for (let input of inputs) {
            !excludedArray.includes(input) && arr.push(meta[input as keyof T].name);
        }
    } else arr = getDetailName(meta, excludedArray);

    return arr.map((field, index) => {
        const isText = meta[field as keyof T].type !== INPUT_TYPE.CHECKBOX
        return (
          <Fragment key={index}>
          {isText ?
          <CC.Stack>
            <CC.Heading size='xs' textTransform='uppercase'>
              {/* {meta[field as keyof T].label}*/}
              {isLabel && isLabel=='name'? meta[field as keyof T].name : meta[field as keyof T].label}
            </CC.Heading>
            <CC.Text pt='2' fontSize='sm' minW={100} minH={10} 
            bgColor={meta[field as keyof T].value ? '':CC.useColorModeValue('gray.200', 'gray.700')}>
              {meta[field as keyof T].value}
            </CC.Text>
          </CC.Stack>
          :
          <CC.HStack>
            <CC.Box pr='2' width={'24px'}>
              {meta[field as keyof T].value?
              <FiCheckCircle size={24} color={'green.500'}/>
              :
              <FiCircle size={24} color={'red.500'}/>
              }
            </CC.Box>
            <CC.Heading size='xs' textTransform='uppercase' style={{'wordWrap':'break-word'}}>
            {isLabel && isLabel=='name'? meta[field as keyof T].name : meta[field as keyof T].label}
            </CC.Heading>
          </CC.HStack>
          }
        </Fragment>
        )
    })
};